import { render } from "./DynamicTabView.vue?vue&type=template&id=0b084e1a&ts=true"
import script from "./DynamicTabView.vue?vue&type=script&lang=ts"
export * from "./DynamicTabView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicTabView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b084e1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b084e1a', __exports__)) {
    api.reload('0b084e1a', __exports__)
  }
  
  module.hot.accept("./DynamicTabView.vue?vue&type=template&id=0b084e1a&ts=true", () => {
    api.rerender('0b084e1a', render)
  })

}


export default __exports__